import axios from "axios";
import { createContext, useEffect, useState } from "react";
import React from "react";

export const userContext = createContext();

const UserRoleContextProvider = ({ children }) => {
  const [token, setToken] = useState();
  const [authenticated, setAuthenticated] = useState(null);
  const [role, setRole] = useState(null);
  // const role = "admin";
  // const authenticated = false;
  // console.log(authenticated, "auth from userRolecp");

  useEffect(() => {
    // console.log(
    //   authenticated,
    //   "this is auth data directly from userRoleContext"
    // );
  }, [authenticated]);

  return (
    <userContext.Provider value={{ authenticated, setAuthenticated, setRole }}>
      {children}
    </userContext.Provider>
  );
};

export default UserRoleContextProvider;
